import { configureStore } from "@reduxjs/toolkit";
import { userNumber } from "../slice/UserNumberSlice";
import { discountedPrice } from "../slice/DiscountedPriceSlice";

const store = configureStore({
  reducer: {
    userNumber: userNumber.reducer,
    price: discountedPrice.reducer,
  },
});

export default store;
